import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="flex min-h-screen flex-col" data-id="element-109">
      <Header data-id="element-110" />
      <main className="flex-1" data-id="element-111">
        <Outlet data-id="element-112" />
      </main>
      <Footer data-id="element-113" />
    </div>;
}